<template>
  <div class="cont">
    <div class="title" :style="{ backgroundImage: 'url(' + curData.title + ')'}" :class="title_object">
      <div class="title_name" :style="{ backgroundImage: 'url(' + curData.title_text + ')'}" :class="title_name_object"></div>
    </div>

    <div class="clear" v-if="id == 'TempTestPaper' ">
      <el-image
        :class="img1"
        style="float:left;margin-bottom:100px"
        :src=" curData.src1  "
        fit="contain"
      >
      </el-image>
      <el-image
        :class="img2"
        style="float:right;"
        :src=" curData.src2  "
        fit="contain"
      >
      </el-image>
      <el-image
        :class="img3"
        style="float:left;margin-bottom:65px"
        :src=" curData.src3  "
        fit="contain"
      >
      </el-image>
      <div style="float:left;width:100%"></div>
      <el-image
        :class="img4"
        style="float:left;margin-bottom:35px"
        :src=" curData.src4  "
        fit="contain"
      >
      </el-image>
      <div style="float:left;width:100%"></div>

      <el-image
        v-if="curData.src5"
        :class="img5"
        style="float:left;"
        :src=" curData.src5  "
        fit="contain"
      >
      </el-image>

    </div>
    <div class="clear" v-else-if="id == 'SilencerCream' ">
      <div style="float:left;width:148px">
        <el-image
          style="width: 148px ; "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="float:right;width:335px;position:relative">
        <el-image
          style="width: 335px ; "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 267px ;position:absolute;top:61px;left:35px "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="float:left;width:380px;margin-top:24px">
        <el-image
          style="width: 370px ; "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="float:left;width:292px;margin-top:92px">
        <el-image
          style="width: 292px ; "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="float:left;width:100%;margin-top:56px">
        <el-image
          style="width: 775px ; "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear" v-else-if="id == 'PeripheralGifts' ">
      <div style="float:left;width:775px;margin-bottom:30px">
        <el-image
          style="width: 775px ; "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="float:left;width:778px;">
        <el-image
          style="width: 778px ; "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      id : '' ,
      pageData : {
        SilencerCream  : {
          name : 'SilencerCream' ,
          title :  require('@/assets/image/variousproducts/otherDetail/SilencerCream/title.png') ,
          title_text :  require('@/assets/image/variousproducts/otherDetail/SilencerCream/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img1.png') ,
          src2 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img2.png') ,
          src3 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img3.png') ,
          src4 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img4.png') ,
          src5 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img5.png') ,
          src6 : require('@/assets/image/variousproducts/otherDetail/SilencerCream/img6.png') ,
        } ,
        TempTestPaper : {
          name : 'TempTestPaper' ,
          title :  require('@/assets/image/variousproducts/otherDetail/TempTestPaper/title.png') ,
          title_text :  require('@/assets/image/variousproducts/otherDetail/TempTestPaper/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/otherDetail/TempTestPaper/img1.png') ,
          src2 : require('@/assets/image/variousproducts/otherDetail/TempTestPaper/img2.png') ,
          src3 : require('@/assets/image/variousproducts/otherDetail/TempTestPaper/img3.png') ,
          src4 : require('@/assets/image/variousproducts/otherDetail/TempTestPaper/img4.png') ,
        } ,
        PeripheralGifts : {
          name : 'PeripheralGifts' ,
          title : require('@/assets/image/variousproducts/otherDetail/SilencerCream/title.png') ,
          title_text :  require('@/assets/image/variousproducts/otherDetail/PeripheralGifts/title_text.png') ,
          src1 : require('@/assets/image/variousproducts/otherDetail/PeripheralGifts/img1.png') ,
          src2 : require('@/assets/image/variousproducts/otherDetail/PeripheralGifts/img2.png') ,
        }, 
        
      },
      curData : {}
    }
  } ,
  methods: {
    getData () {
      let id = this.id
      this.curData = this.pageData[ id ]
    }
  } ,
  created(){
    this.id =  this.$route.params.id  
    this.getData()
  },
  computed: {
    title_object: function () {
      return {
        "t_SilencerCream" : this.curData.name == 'SilencerCream' ,
        't_TempTestPaper' : this.curData.name ==  'TempTestPaper' , 
        't_PeripheralGifts' : this.curData.name ==  'PeripheralGifts' , 
        
      }
    } ,
    title_name_object : function () {
      return {
        "t_n_SilencerCream" : this.curData.name == 'SilencerCream' ,
        't_n_TempTestPaper' : this.curData.name ==  'TempTestPaper' ,
        't_n_PeripheralGifts' : this.curData.name ==  'PeripheralGifts' ,

      }
    } ,
    img1 : function () {
      return {
        "img1_SilencerCream" : this.curData.name == 'SilencerCream' ,
        'img1_TempTestPaper' : this.curData.name ==  'TempTestPaper' ,
      }
    } ,
    img2 : function () {
      return {
        "img2_SilencerCream" : this.curData.name == 'SilencerCream' ,
        'img1_DOT4' : this.curData.name ==  'DOT4' ,
      }
    } ,
    img3 : function () {
      return {
        "img3_SilencerCream" : this.curData.name == 'SilencerCream' ,
        'img1_DOT4' : this.curData.name ==  'DOT4' ,
      }
    } ,
    img4 :  function () {
      return {
        "img4_SilencerCream" : this.curData.name == 'SilencerCream' ,
        'img1_DOT4' : this.curData.name ==  'DOT4' ,
      }
    } ,
    img5 : function () {
      return {
        "img5_SilencerCream" : this.curData.name == 'SilencerCream' ,
        'img1_DOT4' : this.curData.name ==  'DOT4' ,
      }
    } ,
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id 
      this.getData()

      // console.log( from )
    }
  }
}
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after { 
  display: block;
  clear: both;
  content: '';
}

.title { 
  position: absolute;
  left: 66px;
  top: -68px;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  font-size:30px 
  color:#fff;
  text-align :center
}
.t_SilencerCream{
  padding: 30px 31px 27px 37px; 
  width: 170px;
  height: 108px;
}
.t_TempTestPaper{
  padding: 20px 42px 23px 36px; 
  width: 170px;
  height: 108px;
}
.t_PeripheralGifts {
  padding: 33px 42px 23px 36px; 
  width: 170px;
  height: 108px;
}

.title_name {
  background-repeat: no-repeat;
  background-size: contain;
}
.t_n_SilencerCream {
  width: 102px;
  height: 51px;
}
.t_n_TempTestPaper {
  width: 92px;
  height: 65px;
}
.t_n_PeripheralGifts {
  width: 92px;
  height: 49px;
}

.img1_SilencerCream{
  width: 370px;
}
.img1_TempTestPaper{
  width: 414px;

}

.img2_SilencerCream{
  width 283px
}

.img3_SilencerCream{
  width 234px
}
.img4_SilencerCream{
  width 331px
}
.img5_SilencerCream{
  width:329px
}

</style>